<div class="card mb-4">
  <div class="card-header py-2">
    <h6 class="mb-0">Available Products &amp; Base Rates</h6>
  </div>
  <div class="card-body p-0">
    <kendo-grid
      [data]="pagedProducts()"
      [loading]="isLoading()"
      [sortable]="true"
      [pageable]="{ pageSizes: [10, 25, 50], info: true }"
      [pageSize]="pageSize()"
      [skip]="skip()"
      (pageChange)="onPageChange($event)"
    >
      <ng-template kendoGridLoadingTemplate>
        <div class="loader-container">
          <kendo-loader
            type="infinite-spinner"
            size="large"
          ></kendo-loader>
        </div>
      </ng-template>
      <kendo-grid-column
        field="product_name"
        title="Product"
        [width]="220"
      ></kendo-grid-column>
      <kendo-grid-column
        field="sku"
        title="SKU"
        [width]="140"
      ></kendo-grid-column>
      <kendo-grid-column
        field="billing_element"
        title="Billing Element"
        [width]="160"
      ></kendo-grid-column>
      <kendo-grid-column
        field="base_rate"
        title="Base Rate"
        [width]="140"
      >
        <ng-template
          kendoGridCellTemplate
          let-dataItem
        >
          {{ dataItem.base_rate | currency: dataItem.currency : 'symbol' : '1.2-2' }}
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </div>
</div>
